import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Lock, Radar, Sparkles, Gift, Wand2, PawPrint, Target, Images, Bot, Check, ArrowRight, Handshake } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const FULL_PLAN_BENEFITS = [
  [Radar, "Radar GPS 50–500 m", "hasta 1,400 matches al mes con transeúntes reales"],
  [Handshake, "Sistema de Ventas Referidas", "miles de promotores venden por ti; pagas comisión solo al vender"],
  [Gift, "Ofertas y regalos ilimitados", "promos, 2x1 y regalos por horario"],
  [Sparkles, "Aura · guía virtual IA", "chat y voz con 50 min gratis al mes"],
  [Bot, "IA Vendedora entrenada", "con tus productos, precios y argumentos"],
  [Wand2, "Diseño IA de ofertas y catálogo", "8 diseños al mes"],
  [Images, "Catálogo visual de 10 fotos", "Aura lo muestra en el chat"],
  [PawPrint, "MANADA descuentos grupales", "códigos por tamaño de grupo"],
  [Target, "Atínale al Precio", "gamificación que fija tu marca"],
];

/** Modal de upgrade: se muestra cuando un comercio con PAQUETE CUPONES abre un módulo del PAQUETE HOLA RADAR. */
export default function UpgradeDialog({ moduleName, open, onOpenChange }) {
  const navigate = useNavigate();
  const go = () => { onOpenChange(false); navigate("/dashboard/billing?upgrade=full"); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-3xl bg-[#0A0A0A] text-white border border-white/10 p-0 overflow-hidden" data-testid="upgrade-dialog">
        <div className="relative p-6 sm:p-7">
          <div className="absolute -top-20 -right-16 w-56 h-56 rounded-full bg-[#0055FF]/40 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-10 w-56 h-56 rounded-full bg-[#FF007A]/30 blur-3xl pointer-events-none" />
          <div className="relative">
            <div className="flex items-center gap-2">
              <div className="w-11 h-11 rounded-2xl bg-[#0055FF] grid place-items-center"><Lock className="w-5 h-5" /></div>
              <span className="text-[10px] uppercase tracking-[0.2em] font-black text-[#FF007A]">Servicio del PAQUETE HOLA RADAR</span>
            </div>
            <DialogTitle className="font-heading font-extrabold text-2xl sm:text-3xl mt-3 leading-tight">{moduleName} está listo — solo falta activar el plan completo</DialogTitle>
            <DialogDescription className="text-sm text-white/70 mt-2 leading-relaxed">
              Tu PAQUETE CUPONES MARKETING ($299 + IVA) ya incluye cupones, campañas a tu población y boletos del sorteo. Con el <strong className="text-white">PAQUETE HOLA RADAR ($990 MXN + IVA / mes)</strong> desbloqueas TODO:
            </DialogDescription>
            <ul className="mt-4 grid sm:grid-cols-2 gap-2">
              {FULL_PLAN_BENEFITS.map(([Icon, t, d]) => (
                <li key={t} className="flex items-start gap-2 rounded-xl bg-white/[0.06] border border-white/10 p-2.5">
                  <Icon className="w-4 h-4 text-[#f7c948] mt-0.5 shrink-0" />
                  <div><div className="text-xs font-extrabold leading-tight">{t}</div><div className="text-[10px] text-white/60 leading-tight">{d}</div></div>
                </li>
              ))}
            </ul>
            <Button onClick={go} className="mt-5 w-full h-12 rounded-full bg-[#FF007A] hover:bg-[#e6006e] font-black text-base tracking-wide" data-testid="upgrade-dialog-cta">
              <Crown className="w-5 h-5" /> CONTRATAR PLAN COMPLETO <ArrowRight className="w-4 h-4" />
            </Button>
            <div className="mt-2 flex items-center justify-center gap-1 text-[11px] text-white/50"><Check className="w-3 h-3" /> Sin contrato forzoso · conservas todo tu sistema de cupones</div>
            <button type="button" onClick={() => onOpenChange(false)} className="mt-3 w-full text-xs text-white/50 hover:text-white/80" data-testid="upgrade-dialog-later">Seguir con mi paquete por ahora</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

/** Banner persistente sobre la página bloqueada (cuando el comercio cierra el modal). */
export function UpgradeBanner({ moduleName, onOpen }) {
  return (
    <div className="absolute inset-x-6 md:inset-x-10 top-6 z-20" data-testid="locked-overlay">
      <div className="rounded-2xl bg-[#0A0A0A] text-white px-4 py-3 shadow-2xl border border-white/10 flex flex-wrap items-center gap-3">
        <Lock className="w-4 h-4 text-[#FF007A]" />
        <div className="flex-1 min-w-[12rem] text-sm"><strong>{moduleName}</strong> es parte del PAQUETE HOLA RADAR. Lo ves, pero para usarlo contrata el plan completo.</div>
        <Button onClick={onOpen} className="h-9 rounded-full bg-[#FF007A] hover:bg-[#e6006e] font-black text-xs" data-testid="locked-upgrade-btn"><Crown className="w-4 h-4" /> CONTRATAR PLAN COMPLETO</Button>
      </div>
    </div>
  );
}

export function useUpgradeGate(locked) {
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(!!locked); }, [locked]);
  return [open, setOpen];
}
